import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/page-cases/page-cases-view.tsx");
